import { z } from 'zod';

/**
 * 利用企業作成フォームのバリデーションスキーマ
 *
 * @property name - 会社名（必須）
 * @property contactPersonName - 担当者の氏名（必須）
 * @property contactPersonEmail - 登録メールアドレス（必須、メール形式）
 * @property contactPersonPhone - 登録電話番号（必須）
 * @property corporateNumber - 法人番号（任意）
 * @property externalClientId - 外部企業ID（任意）
 * @property groupId - グループID（任意）
 * @property employeeCount - 利用予定者数（必須、半角数字のみ、0以上の整数）
 */
export const createClientSchema = z.object({
  name: z.string().trim().min(1, '会社名を入力してください。'),
  contactPersonName: z.string().trim().min(1, '担当者の氏名を入力してください。'),
  contactPersonEmail: z.email({ message: 'メールアドレスの形式が正しくありません。' }),
  contactPersonPhone: z
    .string()
    .trim()
    .min(1, '登録電話番号を入力してください。')
    .regex(/^[\d-]+$/, '電話番号は数字とハイフンのみ入力してください。'),
  corporateNumber: z.string().optional(),
  externalClientId: z.string().optional(),
  groupId: z.string().optional(),
  employeeCount: z.preprocess(
    val => (typeof val === 'string' && val.trim() === '' ? Number.NaN : val),
    z.coerce
      .number('半角数字で入力してください')
      .int('半角数字で入力してください')
      .gte(0, '0以上の整数を入力してください。')
  ),
  clientFeatureFlags: z.array(z.string()),
});

/**
 * 利用企業作成フォームのフィールド値の型
 */
export type CreateClientFormFieldValues = z.infer<typeof createClientSchema>;
